import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useAuth } from "../contexts/AuthContext";
import { useOnboardingStatus } from "../hooks/useOnboardingStatus";
import { isOnboardingCompleteLocally } from "../utils/onboardingStatus";

/** Paths reachable before the Home tour is finished. */
const EXEMPT_PREFIXES = ["/onboarding", "/invite/", "/shared/"];

function isExemptPath(pathname) {
  if (pathname === "/" || pathname === "") return true;
  return EXEMPT_PREFIXES.some((p) => pathname === p || pathname.startsWith(p));
}

/**
 * Redirects new users (onboardingCompleted === false) to Home tour until they finish.
 */
const OnboardingGuard = ({ children }) => {
  const location = useLocation();
  const { userId } = useAuth();
  const { loading, needsOnboarding } = useOnboardingStatus();

  if (userId && isOnboardingCompleteLocally(userId)) {
    return children;
  }

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (needsOnboarding && !isExemptPath(location.pathname)) {
    return <Navigate to="/?tour=1" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default OnboardingGuard;
